export const EMBED_CUSTOM_EVENT = 'EMBED/CUSTOM_EVENT';
export const PUBLISH = 'EMBED/PUBLISH';
export const SUBSCRIBE = 'EMBED/SUBSCRIBE';
export const UNSUBSCRIBE = 'EMBED/UNSUBSCRIBE';
export const REFRESH_DATA = 'EMBED/REFRESH';
export const PublicationTypes = {
    selection: 'selection',
};
export const SelectionValueTypes = {
    ATTRIBUTE: 'ATTRIBUTE',
    NUMBER: 'NUMBER',
    TIME: 'TIME',
};
export const ComponentTypes = {
    DASHBOARD: 'dashboard',
    VISUAL_BUILDER: 'visual-builder',
    INVENTORY: 'inventory',
    SOURCE_EDITOR: 'source-editor',
    LITE_DASHBOARD: 'lite-dashboard',
};
export var EmbedEventNames;
(function (EmbedEventNames) {
    /**
     * Triggered by document if the component fails to initialize. No data is passed in the event.
     */
    EmbedEventNames["FAILED"] = "composer-init-failed";
    /**
     * Triggered by document when the authorization token expires. No data is passed in the event.
     */
    EmbedEventNames["UNAUTHORIZED"] = "composer-unauthorized";
})(EmbedEventNames || (EmbedEventNames = {}));
export var DashboardEventNames;
(function (DashboardEventNames) {
    /**
     * Triggered by the dashboard when all visuals on the dashboard have been rendered.
     * The data passed in the event includes the dashboard and dashboard data (*`e.detail.dashboard`).
     */
    DashboardEventNames["READY"] = "composer-dashboard-ready";
    /**
     * Triggered when a dashboard resource is loaded.
     * The data passed in the event includes the dashboard and dashboard data (*`e.detail.dashboard`).
     */
    DashboardEventNames["LOADED"] = "composer-dashboard-loaded";
    /**
     * Triggered by the dashboard when a dashboard resource has been successfully saved.
     * The data passed in the event includes the dashboard and dashboard data (*`e.detail.dashboard`).
     */
    DashboardEventNames["SAVED"] = "composer-dashboard-saved";
    /**
     * Triggered by the dashboard when a visual is added to the dashboard.
     * The data passed in the event includes the visual and visual data (*`e.detail.visual`).
     */
    DashboardEventNames["WIDGET_ADDED"] = "composer-dashboard-widget-added";
    /**
     * Triggered by the dashboard when a visual is removed from the dashboard.
     * The data passed in the event includes the visual and visual data (*`e.detail.visual`).
     */
    DashboardEventNames["WIDGET_REMOVED"] = "composer-dashboard-widget-removed";
    /**
     * Triggered by the dashboard when there is any change in the dashboard configuration.
     * This is useful for tracking the active state of the dashboard.
     * The data passed in the event includes the dashboard and dashboard data (*`e.detail.dashboard`).
     */
    DashboardEventNames["CHANGED"] = "composer-dashboard-changed";
    /**
     * Triggered by the dashboard when the dashboard is deleted.
     * The data passed in the event includes the dashboard and dashboard data (*`e.detail.dashboard`).
     */
    DashboardEventNames["DELETED"] = "composer-dashboard-deleted";
    /**
     * Triggered by the dashboard when the dashboard becomes unsaved.
     */
    DashboardEventNames["DIRTY"] = "composer-dashboard-dirty";
    /**
     * Triggered by the dashboard when the dashboard loaded for the first time or when its state was changed from unsaved.
     */
    DashboardEventNames["PRISTINE"] = "composer-dashboard-pristine";
})(DashboardEventNames || (DashboardEventNames = {}));
export var VisualEventNames;
(function (VisualEventNames) {
    /**
     * Triggered by the dashboard or visual authoring when a visual within the dashboard is fully rendered.
     * The data passed in the event includes the visual and visual data as well as the visualization instance ID (*`e.detail.visual`).
     */
    VisualEventNames["RENDERED"] = "composer-visual-rendered";
    /**
     * Triggered by the dashboard or visual authoring when a visual within the dashboard is loaded.
     * The data passed in the event includes the visual and visual data as well as the visualization instance ID (*`e.detail.visual`).
     */
    VisualEventNames["LOADED"] = "composer-visual-loaded";
    /**
     * Triggered by the dashboard or visual authoring when a visual within the dashboard fails to load.
     * The data passed in the event includes the visual and visual data as well as the failure reason (`failedReason`).
     */
    VisualEventNames["FAILED"] = "composer-visual-failed";
    /**
     * Triggered when visual authoring has been successfully saved.
     * The data passed in the event includes the visual authoring configuration (*`e.detail.visual`).
     */
    VisualEventNames["SAVED"] = "composer-visual-saved";
    /**
     * Triggered when use left click on series.
     * The data passed in the event includes visual data (*`e.detail.data`).
     */
    VisualEventNames["SERIES_CLICKED"] = "composer-visual-series-clicked";
    /**
     * Triggered when use touch on series.
     * The data passed in the event includes visual data (*`e.detail.data`).
     */
    VisualEventNames["SERIES_TOUCHED"] = "composer-visual-series-touched";
    /**
     * Triggered when use right click on series.
     * The data passed in the event includes visual data (*`e.detail.data`).
     */
    VisualEventNames["SERIES_RIGHT_CLICKED"] = "composer-visual-series-right-clicked";
    /**
     * Triggered when use touch on series.
     * The data passed in the event includes visual data (*`e.detail.data`).
     */
    VisualEventNames["SERIES_LONG_TOUCHED"] = "composer-visual-series-long-touched";
    /**
     * Triggered when hovering on visual series.
     * The data passed in the event includes visual data (*`e.detail.data`).
     */
    VisualEventNames["SERIES_MOUSE_MOVE"] = "composer-visual-series-mousemove";
    /**
     * Triggered when the mouse leaves visual series.
     * The data passed in the event includes visual data (*`e.detail.data`).
     */
    VisualEventNames["SERIES_MOUSE_OUT"] = "composer-visual-series-mouseout";
    /**
     * Triggered when use left click on visual blank space.
     * The data passed in the event includes visual data (*`e.detail.data`).
     */
    VisualEventNames["VISUAL_CLICKED"] = "composer-visual-clicked";
    /**
     * Triggered when use touch on series.
     * The data passed in the event includes visual data (*`e.detail.data`).
     */
    VisualEventNames["VISUAL_TOUCHED"] = "composer-visual-touched";
    /**
     * Triggered when use right click on visual blank space.
     * The data passed in the event includes visual data (*`e.detail.data`).
     */
    VisualEventNames["VISUAL_RIGHT_CLICKED"] = "composer-visual-right-clicked";
    /**
     * Triggered when use touch on series.
     * The data passed in the event includes visual data (*`e.detail.data`).
     */
    VisualEventNames["VISUAL_LONG_TOUCHED"] = "composer-visual-long-touched";
    /**
     * Triggered when hovering on visual blank space.
     */
    VisualEventNames["VISUAL_MOUSE_MOVE"] = "composer-visual-mousemove";
    /**
     * Triggered when the mouse leaves a visual.
     */
    VisualEventNames["VISUAL_MOUSE_OUT"] = "composer-visual-mouseout";
})(VisualEventNames || (VisualEventNames = {}));
export var VisualBuilderEventNames;
(function (VisualBuilderEventNames) {
    /**
     * Triggered when the nested visual is rendered.
     * The data passed in the event includes the visual authoring configuration (*`e.detail.visualBuilder`).
     */
    VisualBuilderEventNames["READY"] = "composer-visual-builder-ready";
    /**
     * Triggered when visual authoring is loaded and the visual authoring shell is rendered.
     * The data passed in the event includes the visual authoring configuration (*`e.detail.visualBuilder`).
     */
    VisualBuilderEventNames["LOADED"] = "composer-visual-builder-loaded";
    /**
     * Triggered when visual authoring fails to load.
     * The data passed in the event includes the failure reason (*`e.detail.failedReason`).
     */
    VisualBuilderEventNames["FAILED"] = "composer-visual-builder-failed";
    /**
     * Triggered when there is any change in the nested visual or the visual authoring configuration.
     * The data passed in the event includes the visual authoring configuration (*`e.detail.visualBuilder`).
     */
    VisualBuilderEventNames["CHANGED"] = "composer-visual-builder-changed";
})(VisualBuilderEventNames || (VisualBuilderEventNames = {}));
export var InventoryEventNames;
(function (InventoryEventNames) {
    /**
     * Triggered when the inventory rendered first time.
     */
    InventoryEventNames["READY"] = "composer-inventory-ready";
    /**
     * Triggered when inventory items have been loaded.
     * The data passed in the event includes the inventory items (*`e.detail.inventoryItems`).
     */
    InventoryEventNames["LOADED"] = "composer-inventory-loaded";
    /**
     * Triggered when the inventory fails to load.
     * The data passed in the event includes the failure reason (*`e.detail.failedReason`).
     */
    InventoryEventNames["FAILED"] = "composer-inventory-failed";
    /**
     * Triggered when a inventory item has been deleted.
     * The data passed in the event includes the deleted inventory item data (*`e.detail.inventoryItem`).
     */
    InventoryEventNames["ITEM_DELETED"] = "composer-inventory-item-deleted";
})(InventoryEventNames || (InventoryEventNames = {}));
export var SourceEditorEventNames;
(function (SourceEditorEventNames) {
    /**
     * Triggered when the source editor rendered first time.
     */
    SourceEditorEventNames["READY"] = "composer-source-editor-ready";
    /**
     * Triggered when a source has been loaded on Source Creation tab (*`e.detail.source`).
     */
    SourceEditorEventNames["SOURCE_DEFINITION_READY"] = "composer-source-definition-ready";
    /**
     * Triggered when source fields have been loaded on Fields tab (*`e.detail.fields`).
     */
    SourceEditorEventNames["SOURCE_FIELDS_READY"] = "composer-source-fields-ready";
    /**
     * Triggered when source cache settings have been loaded on Cache tab (*`e.detail.cache`).
     */
    SourceEditorEventNames["SOURCE_CACHE_READY"] = "composer-source-cache-ready";
    /**
     * Triggered when source global settings have been loaded on Global Settings tab (*`e.detail.settings`).
     */
    SourceEditorEventNames["SOURCE_SETTINGS_READY"] = "composer-source-settings-ready";
    /**
     * Triggered when a source has been created (*`e.detail.source`).
     */
    SourceEditorEventNames["CREATED"] = "composer-source-created";
    /**
     * Triggered when a source has been saved (*`e.detail.source`).
     */
    SourceEditorEventNames["SAVED"] = "composer-source-saved";
    SourceEditorEventNames["DELETED"] = "composer-source-deleted";
    SourceEditorEventNames["FAILED"] = "composer-source-failed";
    /**
     * Triggered when a source field has been created (*`e.detail.field`).
     */
    SourceEditorEventNames["SOURCE_FEILD_CREATED"] = "composer-source-field-created";
    /**
     * Triggered when a source field has been saved (*`e.detail.field`).
     */
    SourceEditorEventNames["SOURCE_FEILD_SAVED"] = "composer-source-field-saved";
    /**
     * Triggered when a source field has been deleted (*`e.detail.field`).
     */
    SourceEditorEventNames["SOURCE_FEILD_DELETED"] = "composer-source-field-deleted";
    /**
     * Triggered when a source metric has been created (*`e.detail.metric`).
     */
    SourceEditorEventNames["SOURCE_METRIC_CREATED"] = "composer-source-metric-created";
    /**
     * Triggered when a source metric has been saved (*`e.detail.metric`).
     */
    SourceEditorEventNames["SOURCE_METRIC_SAVED"] = "composer-source-metric-saved";
    /**
     * Triggered when a source metric has been deleted (*`e.detail.metric`).
     */
    SourceEditorEventNames["SOURCE_METRIC_DELETED"] = "composer-source-metric-deleted";
})(SourceEditorEventNames || (SourceEditorEventNames = {}));
export var InteractivityProfile;
(function (InteractivityProfile) {
    InteractivityProfile["READ_ONLY"] = "readonly";
    InteractivityProfile["INTERACTIVE"] = "interactive";
    InteractivityProfile["EMBEDDED"] = "embedded";
    InteractivityProfile["LINKED"] = "linked";
    InteractivityProfile["LITE"] = "lite";
})(InteractivityProfile || (InteractivityProfile = {}));
export const isSuccessfulTokenResponse = (tokenResponce) => {
    return 'access_token' in tokenResponce;
};
export const EditorPlacements = {
    DOCK_RIGHT: 'dockRight',
    MODALS: 'modals',
};
export const DashboardSettingsPlacement = {
    SINGLE_PANEL: 'singlePanel',
    MULTIPLE_PANELS: 'multiplePanels',
};
export var DashboardSettingKeys;
(function (DashboardSettingKeys) {
    DashboardSettingKeys["ADD_TO_FAVORITES"] = "ADD_TO_FAVORITES";
    DashboardSettingKeys["ADD_VISUALS"] = "ADD_VISUALS";
    DashboardSettingKeys["CHANGE_DESCRIPTION"] = "CHANGE_DESCRIPTION";
    DashboardSettingKeys["CHANGE_LAYOUT"] = "CHANGE_LAYOUT";
    DashboardSettingKeys["COMMENTS"] = "COMMENTS";
    DashboardSettingKeys["CREATE_FILTER_SNIPPETS"] = "CREATE_FILTER_SNIPPETS";
    /**
     * @deprecated
     * Please, use `CREATE_TEXT_SNIPPETS` and `CREATE_FILTER_SNIPPETS` properties instead.
     */
    DashboardSettingKeys["CREATE_SNIPPETS"] = "CREATE_SNIPPETS";
    DashboardSettingKeys["CREATE_TEXT_SNIPPETS"] = "CREATE_TEXT_SNIPPETS";
    DashboardSettingKeys["CREATE_VISUALS"] = "CREATE_VISUALS";
    DashboardSettingKeys["DASHBOARD_ALERTS"] = "DASHBOARD_ALERTS";
    DashboardSettingKeys["DASHBOARD_INTERACTIONS"] = "DASHBOARD_INTERACTIONS";
    DashboardSettingKeys["DASHBOARD_LINKS"] = "DASHBOARD_LINKS";
    DashboardSettingKeys["DELETE"] = "DELETE";
    DashboardSettingKeys["DESCRIBE_VISUALS"] = "DESCRIBE_VISUALS";
    DashboardSettingKeys["EXPORT_CONFIGURATION"] = "EXPORT_CONFIGURATION";
    DashboardSettingKeys["EXPORT_DATA"] = "EXPORT_DATA";
    DashboardSettingKeys["EXPORT_PNG_PDF"] = "EXPORT_PNG_PDF";
    DashboardSettingKeys["FILTER"] = "FILTER";
    DashboardSettingKeys["MANAGE_TAGS"] = "MANAGE_TAGS";
    DashboardSettingKeys["REFRESH"] = "REFRESH";
    DashboardSettingKeys["RENAME"] = "RENAME";
    DashboardSettingKeys["SCHEDULE_REPORTS"] = "SCHEDULE_REPORTS";
    DashboardSettingKeys["SAVE"] = "SAVE";
    DashboardSettingKeys["SAVE_AS"] = "SAVE_AS";
    DashboardSettingKeys["SHARE_DASHBOARD"] = "SHARE_DASHBOARD";
    DashboardSettingKeys["SHARE_FILTER_SETS"] = "SHARE_FILTER_SETS";
    DashboardSettingKeys["WIDGET_SETTINGS"] = "WIDGET_SETTINGS";
})(DashboardSettingKeys || (DashboardSettingKeys = {}));
export var VisualSettingKeys;
(function (VisualSettingKeys) {
    VisualSettingKeys["ACTIONS"] = "ACTIONS";
    VisualSettingKeys["ACTIONS_ACTION"] = "ACTIONS_ACTION";
    VisualSettingKeys["COLORS"] = "COLORS";
    VisualSettingKeys["CONDITIONAL_FORMATTING"] = "CONDITIONAL_FORMATTING";
    VisualSettingKeys["COPY"] = "COPY";
    VisualSettingKeys["DETAILS_ACTION"] = "DETAILS_ACTION";
    VisualSettingKeys["EXCLUDE_ACTION"] = "EXCLUDE_ACTION";
    /**
     * @deprecated
     * Please, use any of `EXPORT_PNG_PDF','EXPORT_CSV', or 'EXPORT_XLSX' properties instead.
     */
    VisualSettingKeys["EXPORT"] = "EXPORT";
    VisualSettingKeys["EXPORT_CSV"] = "EXPORT_CSV";
    VisualSettingKeys["EXPORT_PNG_PDF"] = "EXPORT_PNG_PDF";
    VisualSettingKeys["EXPORT_XLSX"] = "EXPORT_XLSX";
    VisualSettingKeys["FILTER"] = "FILTER";
    VisualSettingKeys["FILTER_ACTION"] = "FILTER_ACTION";
    VisualSettingKeys["FORMAT"] = "FORMAT";
    VisualSettingKeys["GROUPING"] = "GROUPING";
    VisualSettingKeys["INFO"] = "INFO";
    VisualSettingKeys["KEYSET"] = "KEYSET";
    VisualSettingKeys["KEYSET_ACTION"] = "KEYSET_ACTION";
    VisualSettingKeys["LINK_ACTION"] = "LINK_ACTION";
    VisualSettingKeys["MANAGE_TAGS"] = "MANAGE_TAGS";
    VisualSettingKeys["MAXIMIZE"] = "MAXIMIZE";
    VisualSettingKeys["METRICS"] = "METRICS";
    VisualSettingKeys["REMOVE"] = "REMOVE";
    VisualSettingKeys["RENAME"] = "RENAME";
    VisualSettingKeys["RULERS"] = "RULERS";
    VisualSettingKeys["SAVE"] = "SAVE";
    VisualSettingKeys["SAVE_AS"] = "SAVE_AS";
    VisualSettingKeys["SETTINGS"] = "SETTINGS";
    VisualSettingKeys["SETTINGS_ACTION"] = "SETTINGS_ACTION";
    VisualSettingKeys["SORT"] = "SORT";
    VisualSettingKeys["TIMEBAR_FIELD"] = "TIMEBAR_FIELD";
    VisualSettingKeys["TIMEBAR_PANEL"] = "TIMEBAR_PANEL";
    VisualSettingKeys["TREND_ACTION"] = "TREND_ACTION";
    VisualSettingKeys["VISUAL_STYLE"] = "VISUAL_STYLE";
    VisualSettingKeys["ZOOM_ACTION"] = "ZOOM_ACTION";
})(VisualSettingKeys || (VisualSettingKeys = {}));
export var SettingTypes;
(function (SettingTypes) {
    SettingTypes["DASHBOARD"] = "settings";
    SettingTypes["VISUAL"] = "visualSettings";
})(SettingTypes || (SettingTypes = {}));
export var VisualLegendTypes;
(function (VisualLegendTypes) {
    VisualLegendTypes["STATIC_LEGEND"] = "staticLegend";
    VisualLegendTypes["DYNAMIC_LEGEND"] = "dynamicLegend";
})(VisualLegendTypes || (VisualLegendTypes = {}));
export var SeriesActionItems;
(function (SeriesActionItems) {
    SeriesActionItems["ACTIONS"] = "actions";
    SeriesActionItems["EXCLUDE"] = "exclude";
    SeriesActionItems["FILTER"] = "filter";
    SeriesActionItems["INFO"] = "details";
    SeriesActionItems["KEYSET"] = "keyset";
    SeriesActionItems["LINK"] = "link";
    SeriesActionItems["SETTINGS"] = "settings";
    SeriesActionItems["TREND"] = "trend";
    SeriesActionItems["ZOOM"] = "zoom";
})(SeriesActionItems || (SeriesActionItems = {}));
export var BlankSpaceActionItems;
(function (BlankSpaceActionItems) {
    BlankSpaceActionItems["ACTIONS"] = "actions";
    BlankSpaceActionItems["INFO"] = "details";
    BlankSpaceActionItems["KEYSET"] = "keyset";
    BlankSpaceActionItems["SETTINGS"] = "settings";
})(BlankSpaceActionItems || (BlankSpaceActionItems = {}));
export const VIS_TYPES = {
    ARC: 'ARC',
    BLANK: 'BLANK',
    BOX_PLOT: 'BOX_PLOT',
    BUBBLES: 'BUBBLES',
    BULLET_GAUGE: 'BULLET_GAUGE',
    COMBO_CHART: 'COMBO_CHART',
    CUSTOM: 'CUSTOM',
    DONUT: 'DONUT',
    FLOATING_BUBBLES: 'FLOATING_BUBBLES',
    HEAT_MAP: 'HEAT_MAP',
    HISTOGRAM: 'HISTOGRAM',
    KPI: 'KPI',
    LINE_AND_BARS: 'LINE_AND_BARS',
    LINE_CHART: 'LINE_CHART',
    LINE_CHART_CONTINUOUS: 'LINE_CHART_CONTINUOUS',
    LIST_FILTER: 'LIST_FILTER',
    MAP_LAT_LONG: 'MAP_LAT_LONG',
    MULTI_METRIC_BARS: 'MULTI_METRIC_BARS',
    PIE: 'PIE',
    SUN_BURST: 'SUN_BURST',
    PIVOT_TABLE: 'PIVOT_TABLE',
    RAW_DATA_TABLE: 'RAW_DATA_TABLE',
    SCATTERPLOT: 'SCATTERPLOT',
    TREE_MAP: 'TREE_MAP',
    UBER_BARS: 'UBER_BARS',
    US_MAP: 'US_MAP',
    WATERFALL: 'WATERFALL',
    WORD_CLOUD: 'WORD_CLOUD',
    WORLD_MAP: 'WORLD_MAP',
};
//# sourceMappingURL=types.js.map